import { useState } from "react";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";

import minus from '../../img/Accounts/minus.svg';
import plus from '../../img/Accounts/plus.svg';

function FAQ() {
  const { t } = useTranslation();
  
  const [activeIndex, setActiveIndex] = useState(0);

  const data = [
    { question: t('account.21'), answer: t('account.22') },
    { question: t('account.23'), answer: t('account.24') },
    { question: t('account.25'), answer: t('account.26') },
    { question: t('account.29'), answer: t('account.30') }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="relative pt-[80px] xl:pt-[160px] overflow-hidden">
      <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col xl:flex-row justify-between gap-[20px]">
        <p className="text-[24px] xl:text-[36px] zen-dots">{t('account.20')}</p>
        <div className="flex flex-col xl:w-[807px] border-[#00000033] border-t border-l border-r bg-[#FFFFFF]">
          {data.map((item, index) => (
            <div key={index} className="border-b border-[#00000033] py-[15px]">
              <div
                className="flex justify-between items-center cursor-pointer"
                onClick={() => toggleAccordion(index)}
              >
                <p className="text-[14px] ibm-plex font-[600] text-[#000000B2] xl:max-w-[636px] mx-[20px] xl:mx-[40px]">
                  {item.question}
                </p>
                <img
                  src={activeIndex === index ? minus : plus}
                  alt="toggle"
                  className="w-[30px] h-[30px] flex-shrink-0 mx-[20px]"
                />
              </div>

              <AnimatePresence>
                {activeIndex === index && (
                  <motion.div
                    key="content"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                    className="overflow-hidden"
                  >
                    <div className="mt-[10px] text-[14px] ibm-plex text-[#000000B2] xl:max-w-[636px] mx-[20px] xl:mx-[40px]">
                      {item.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FAQ;
